import { render, staticRenderFns } from "./CharacterFolderList.vue?vue&type=template&id=2f65bd87&scoped=true"
import script from "./CharacterFolderList.vue?vue&type=script&lang=ts"
export * from "./CharacterFolderList.vue?vue&type=script&lang=ts"
import style0 from "./CharacterFolderList.vue?vue&type=style&index=0&id=2f65bd87&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f65bd87",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/nola-frontend/nola-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2f65bd87')) {
      api.createRecord('2f65bd87', component.options)
    } else {
      api.reload('2f65bd87', component.options)
    }
    module.hot.accept("./CharacterFolderList.vue?vue&type=template&id=2f65bd87&scoped=true", function () {
      api.rerender('2f65bd87', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/organisms/CharacterFolderList.vue"
export default component.exports